import script from "./RecursiveObjects.vue?vue&type=script&setup=true&lang=js"
export * from "./RecursiveObjects.vue?vue&type=script&setup=true&lang=js"

import "./RecursiveObjects.vue?vue&type=style&index=0&id=06e5e012&lang=scss&scoped=true"

import exportComponent from "C:\\AQ_Repo\\customermanagedinspection_fe - Brandsäkra Norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06e5e012"]])

export default __exports__